import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { api, fileUrl } from "@/lib/api";
import PageHeader from "@/components/PageHeader";
import { Reveal } from "@/components/Reveal";
import CTASection from "@/components/CTASection";
import { useSeo } from "@/hooks/useSeo";

export default function Blog() {
  useSeo("Advice & Insights | StoneCrest Exterior Specialists", "Expert advice on roof cleaning, render softwashing, driveway restoration and exterior property care in Lancashire from StoneCrest Exterior Specialists.", "https://stonecrestexteriors.co.uk/blog");
  const [posts, setPosts] = useState([]);
  useEffect(() => { api.get("/blog").then((r) => setPosts(r.data)).catch(() => {}); }, []);

  return (
    <div>
      <PageHeader overline="Advice & Insights" lines={["Exterior care,", "explained."]} subtitle="Guides and advice to help you understand and protect your property's exterior." />
      <section className="px-6 md:px-12 max-w-7xl mx-auto pb-24 md:pb-32">
        {posts.length === 0 ? (
          <p className="font-serif text-2xl italic text-[var(--muted)] py-16">Articles coming soon.</p>
        ) : (
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {posts.map((p, i) => (
              <Reveal key={p.id} delay={(i % 3) * 0.06}>
                <Link to={`/blog/${p.slug}`} data-testid={`blog-card-${p.slug}`} className="group block border border-transparent hover:border-[var(--border)] transition-all duration-500 h-full">
                  {p.cover_image && (
                    <div className="aspect-[16/10] overflow-hidden">
                      <img src={fileUrl(p.cover_image)} alt={p.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" />
                    </div>
                  )}
                  <div className="pt-6">
                    <h2 className="font-serif text-2xl md:text-3xl leading-snug mb-3 group-hover:text-[var(--oxblood)] transition-colors">{p.title}</h2>
                    <p className="text-sm text-[var(--muted)] leading-relaxed mb-4">{p.excerpt}</p>
                    <span className="text-xs uppercase tracking-[0.2em] flex items-center gap-2 text-[var(--oxblood)]">Read more <ArrowUpRight className="w-3.5 h-3.5" /></span>
                  </div>
                </Link>
              </Reveal>
            ))}
          </div>
        )}
      </section>
      <CTASection />
    </div>
  );
}
